import React from 'react';
import PropTypes from 'prop-types';
import {coral, grey, supportColors} from 'components/primitives/color';
import ReactSelect from 'react-select';
import {DropdownIndicator} from './DropdownIndicator';
import {Option} from './Option';

const fontStyle = {
    'font-family': '\'Roboto\', sans-serif',
    'font-size': '16px'
};

const regularBorder = `inset 0 0 0 1px ${grey.grey400}`;
const focusedBorder = `inset 0 0 0 2px ${coral.regular}`;
const typingBorder = `inset 0 0 0 2px ${coral.light}`;
const errorBorder = `inset 0 0 0 2px ${supportColors.crimson}`;


export class Select extends React.Component {
    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.object),
        onMenuOpen: PropTypes.func,
        onMenuClose: PropTypes.func,
        getOptionLabel: PropTypes.func,
        getOptionValue: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        hasError: PropTypes.bool,
        onChange: PropTypes.func,
        className: PropTypes.string,
        fullWidth: PropTypes.bool,
        isDisabled: PropTypes.bool,
        components: PropTypes.object,
        isMulti: PropTypes.bool,
        isClearable: PropTypes.bool,
        autoFocus: PropTypes.bool
    };

    static defaultProps = {
        getOptionLabel: (option) => option.label,
        getOptionValue: (option) => option.value
    };

    controlStyle = (base, state) => {
        const regularState = !this.props.hasError & !state.isFocused && (state.selectProps.inputValue === '');
        const focusedState = !this.props.hasError & state.isFocused && (state.selectProps.inputValue === '');
        const typingState = !this.props.hasError & state.isFocused && (state.selectProps.inputValue !== '');
        const errorState = this.props.hasError;

        let borderStyle;
        if (regularState) {
            borderStyle = regularBorder;
        }
        if (focusedState) {
            borderStyle = focusedBorder;
        }
        if (typingState) {
            borderStyle = typingBorder;
        }
        if (errorState) {
            borderStyle = errorBorder;
        }

        return {
            ...base,
            ...fontStyle,
            'width': this.props.fullWidth ? '100%' : '280px',
            'height': '36px',
            'min-height': '36px',
            'border-radius': 0,
            'box-shadow': borderStyle,
            'background-color': state.isDisabled ? grey.grey900 : '#fff',
            'cursor': state.isDisabled ? 'not-allowed' : 'default',
            'box-sizing': 'border-box',
            // Remvoe default unwanted styling that comes from the spread
            '&:hover': {},
            'border': 'none',
            'borderRadius': '0',
            'borderWidth': '0'
        };
    };

    selectStyles = {
        placeholder: (base) => ({
            ...base,
            ...fontStyle
        }),
        option: (base) => ({
            ...base,
            ...fontStyle
        }),
        control: (base, state) => this.controlStyle(base, state),
        container: (base) => ({
            ...base
        }),
        menu: (base) => ({
            ...base,
            top: '28px'
        })
    };

    render() {
        const {components, ...props} = this.props;
        return (
            <ReactSelect
                {...props}
                styles={this.selectStyles}
                classNamePrefix='debug'
                components={Object.assign({}, {DropdownIndicator, Option}, components)}
            >
            </ReactSelect>
        );
    }
}
